<span
  *ngIf="condonado as monto"
  class="enf-chip is-muted enf-chip-block enf-writeoff"
  tabindex="0"
  [attr.aria-label]="'Residuo condonado de ' + (monto | currency) + ': no es dinero cobrado'"
  [pTooltip]="'Se condonaron ' + (monto | currency) + ' con el editor de saldos. No es dinero cobrado: el pendiente ya lo descuenta.'"
  tooltipPosition="top"
  >residuo condonado {{ monto | currency }}</span
>
